/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as UnavailableRouteImport } from './routes/unavailable'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminExportsRouteImport } from './routes/admin.exports'
import { Route as AdminInboxRouteImport } from './routes/admin.inbox'
import { Route as AdminPreferencesRouteImport } from './routes/admin.preferences'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminDashboardsIndexRouteImport } from './routes/admin.dashboards.index'
import { Route as AdminDashboardsDashboardIdRouteImport } from './routes/admin.dashboards.$dashboardId'
import { Route as AdminFiltersIndexRouteImport } from './routes/admin.filters.index'
import { Route as AdminFiltersFilterIdRouteImport } from './routes/admin.filters.$filterId'
import { Route as AdminIIssueKeyRouteImport } from './routes/admin.i.$issueKey'
import { Route as AdminMyIndexRouteImport } from './routes/admin.my.index'
import { Route as AdminMyDueRouteImport } from './routes/admin.my.due'
import { Route as AdminMyRecentRouteImport } from './routes/admin.my.recent'
import { Route as AdminMyReportedRouteImport } from './routes/admin.my.reported'
import { Route as AdminMyWatchingRouteImport } from './routes/admin.my.watching'
import { Route as AdminPProjectKeyRouteImport } from './routes/admin.p.$projectKey'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin.settings.index'
import { Route as AdminSettingsAuditRouteImport } from './routes/admin.settings.audit'
import { Route as AdminSettingsGithubRouteImport } from './routes/admin.settings.github'
import { Route as AdminSettingsImportRouteImport } from './routes/admin.settings.import'
import { Route as AdminSettingsLabelsRouteImport } from './routes/admin.settings.labels'
import { Route as AdminSettingsPeopleRouteImport } from './routes/admin.settings.people'
import { Route as AdminSettingsSlackRouteImport } from './routes/admin.settings.slack'
import { Route as AdminSettingsTokensRouteImport } from './routes/admin.settings.tokens'
import { Route as AdminSettingsTrashRouteImport } from './routes/admin.settings.trash'
import { Route as AdminSettingsUsageRouteImport } from './routes/admin.settings.usage'
import { Route as AdminSettingsWebhooksRouteImport } from './routes/admin.settings.webhooks'
import { Route as AdminPProjectKeyIndexRouteImport } from './routes/admin.p.$projectKey.index'
import { Route as AdminPProjectKeyIssueKeyRouteImport } from './routes/admin.p.$projectKey.$issueKey'
import { Route as AdminPProjectKeyAutomationRouteImport } from './routes/admin.p.$projectKey.automation'
import { Route as AdminPProjectKeyBacklogRouteImport } from './routes/admin.p.$projectKey.backlog'
import { Route as AdminPProjectKeyCalendarRouteImport } from './routes/admin.p.$projectKey.calendar'
import { Route as AdminPProjectKeyImportRouteImport } from './routes/admin.p.$projectKey.import'
import { Route as AdminPProjectKeyListRouteImport } from './routes/admin.p.$projectKey.list'
import { Route as AdminPProjectKeyReportsRouteImport } from './routes/admin.p.$projectKey.reports'
import { Route as AdminPProjectKeySettingsRouteImport } from './routes/admin.p.$projectKey.settings'
import { Route as AdminPProjectKeyTimelineRouteImport } from './routes/admin.p.$projectKey.timeline'
import { Route as AdminPProjectKeyReleasesIndexRouteImport } from './routes/admin.p.$projectKey.releases.index'
import { Route as AdminPProjectKeyReleasesReleaseIdRouteImport } from './routes/admin.p.$projectKey.releases.$releaseId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const UnavailableRoute = UnavailableRouteImport.update({
  id: '/unavailable',
  path: '/unavailable',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExportsRoute = AdminExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInboxRoute = AdminInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPreferencesRoute = AdminPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardsIndexRoute = AdminDashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardsDashboardIdRoute =
  AdminDashboardsDashboardIdRouteImport.update({
    id: '/dashboards/$dashboardId',
    path: '/dashboards/$dashboardId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminFiltersIndexRoute = AdminFiltersIndexRouteImport.update({
  id: '/filters/',
  path: '/filters/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFiltersFilterIdRoute = AdminFiltersFilterIdRouteImport.update({
  id: '/filters/$filterId',
  path: '/filters/$filterId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIIssueKeyRoute = AdminIIssueKeyRouteImport.update({
  id: '/i/$issueKey',
  path: '/i/$issueKey',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyIndexRoute = AdminMyIndexRouteImport.update({
  id: '/my/',
  path: '/my/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyDueRoute = AdminMyDueRouteImport.update({
  id: '/my/due',
  path: '/my/due',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyRecentRoute = AdminMyRecentRouteImport.update({
  id: '/my/recent',
  path: '/my/recent',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyReportedRoute = AdminMyReportedRouteImport.update({
  id: '/my/reported',
  path: '/my/reported',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyWatchingRoute = AdminMyWatchingRouteImport.update({
  id: '/my/watching',
  path: '/my/watching',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPProjectKeyRoute = AdminPProjectKeyRouteImport.update({
  id: '/p/$projectKey',
  path: '/p/$projectKey',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsAuditRoute = AdminSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsGithubRoute = AdminSettingsGithubRouteImport.update({
  id: '/github',
  path: '/github',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsImportRoute = AdminSettingsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsLabelsRoute = AdminSettingsLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsPeopleRoute = AdminSettingsPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsSlackRoute = AdminSettingsSlackRouteImport.update({
  id: '/slack',
  path: '/slack',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsTokensRoute = AdminSettingsTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsTrashRoute = AdminSettingsTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsUsageRoute = AdminSettingsUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsWebhooksRoute = AdminSettingsWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminPProjectKeyIndexRoute = AdminPProjectKeyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPProjectKeyRoute,
} as any)
const AdminPProjectKeyIssueKeyRoute =
  AdminPProjectKeyIssueKeyRouteImport.update({
    id: '/$issueKey',
    path: '/$issueKey',
    getParentRoute: () => AdminPProjectKeyRoute,
  } as any)
const AdminPProjectKeyAutomationRoute =
  AdminPProjectKeyAutomationRouteImport.update({
    id: '/automation',
    path: '/automation',
    getParentRoute: () => AdminPProjectKeyRoute,
  } as any)
const AdminPProjectKeyBacklogRoute = AdminPProjectKeyBacklogRouteImport.update({
  id: '/backlog',
  path: '/backlog',
  getParentRoute: () => AdminPProjectKeyRoute,
} as any)
const AdminPProjectKeyCalendarRoute =
  AdminPProjectKeyCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AdminPProjectKeyRoute,
  } as any)
const AdminPProjectKeyImportRoute = AdminPProjectKeyImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AdminPProjectKeyRoute,
} as any)
const AdminPProjectKeyListRoute = AdminPProjectKeyListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => AdminPProjectKeyRoute,
} as any)
const AdminPProjectKeyReportsRoute = AdminPProjectKeyReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminPProjectKeyRoute,
} as any)
const AdminPProjectKeySettingsRoute =
  AdminPProjectKeySettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AdminPProjectKeyRoute,
  } as any)
const AdminPProjectKeyTimelineRoute =
  AdminPProjectKeyTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AdminPProjectKeyRoute,
  } as any)
const AdminPProjectKeyReleasesIndexRoute =
  AdminPProjectKeyReleasesIndexRouteImport.update({
    id: '/releases/',
    path: '/releases/',
    getParentRoute: () => AdminPProjectKeyRoute,
  } as any)
const AdminPProjectKeyReleasesReleaseIdRoute =
  AdminPProjectKeyReleasesReleaseIdRouteImport.update({
    id: '/releases/$releaseId',
    path: '/releases/$releaseId',
    getParentRoute: () => AdminPProjectKeyRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/unavailable': typeof UnavailableRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/preferences': typeof AdminPreferencesRoute
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/admin/dashboards/$dashboardId': typeof AdminDashboardsDashboardIdRoute
  '/admin/filters/$filterId': typeof AdminFiltersFilterIdRoute
  '/admin/i/$issueKey': typeof AdminIIssueKeyRoute
  '/admin/my/due': typeof AdminMyDueRoute
  '/admin/my/recent': typeof AdminMyRecentRoute
  '/admin/my/reported': typeof AdminMyReportedRoute
  '/admin/my/watching': typeof AdminMyWatchingRoute
  '/admin/p/$projectKey': typeof AdminPProjectKeyRouteWithChildren
  '/admin/settings/audit': typeof AdminSettingsAuditRoute
  '/admin/settings/github': typeof AdminSettingsGithubRoute
  '/admin/settings/import': typeof AdminSettingsImportRoute
  '/admin/settings/labels': typeof AdminSettingsLabelsRoute
  '/admin/settings/people': typeof AdminSettingsPeopleRoute
  '/admin/settings/slack': typeof AdminSettingsSlackRoute
  '/admin/settings/tokens': typeof AdminSettingsTokensRoute
  '/admin/settings/trash': typeof AdminSettingsTrashRoute
  '/admin/settings/usage': typeof AdminSettingsUsageRoute
  '/admin/settings/webhooks': typeof AdminSettingsWebhooksRoute
  '/admin/dashboards/': typeof AdminDashboardsIndexRoute
  '/admin/filters/': typeof AdminFiltersIndexRoute
  '/admin/my/': typeof AdminMyIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/p/$projectKey/$issueKey': typeof AdminPProjectKeyIssueKeyRoute
  '/admin/p/$projectKey/automation': typeof AdminPProjectKeyAutomationRoute
  '/admin/p/$projectKey/backlog': typeof AdminPProjectKeyBacklogRoute
  '/admin/p/$projectKey/calendar': typeof AdminPProjectKeyCalendarRoute
  '/admin/p/$projectKey/import': typeof AdminPProjectKeyImportRoute
  '/admin/p/$projectKey/list': typeof AdminPProjectKeyListRoute
  '/admin/p/$projectKey/reports': typeof AdminPProjectKeyReportsRoute
  '/admin/p/$projectKey/settings': typeof AdminPProjectKeySettingsRoute
  '/admin/p/$projectKey/timeline': typeof AdminPProjectKeyTimelineRoute
  '/admin/p/$projectKey/': typeof AdminPProjectKeyIndexRoute
  '/admin/p/$projectKey/releases/$releaseId': typeof AdminPProjectKeyReleasesReleaseIdRoute
  '/admin/p/$projectKey/releases/': typeof AdminPProjectKeyReleasesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signed-out': typeof SignedOutRoute
  '/unavailable': typeof UnavailableRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/preferences': typeof AdminPreferencesRoute
  '/admin': typeof AdminIndexRoute
  '/admin/dashboards/$dashboardId': typeof AdminDashboardsDashboardIdRoute
  '/admin/filters/$filterId': typeof AdminFiltersFilterIdRoute
  '/admin/i/$issueKey': typeof AdminIIssueKeyRoute
  '/admin/my/due': typeof AdminMyDueRoute
  '/admin/my/recent': typeof AdminMyRecentRoute
  '/admin/my/reported': typeof AdminMyReportedRoute
  '/admin/my/watching': typeof AdminMyWatchingRoute
  '/admin/settings/audit': typeof AdminSettingsAuditRoute
  '/admin/settings/github': typeof AdminSettingsGithubRoute
  '/admin/settings/import': typeof AdminSettingsImportRoute
  '/admin/settings/labels': typeof AdminSettingsLabelsRoute
  '/admin/settings/people': typeof AdminSettingsPeopleRoute
  '/admin/settings/slack': typeof AdminSettingsSlackRoute
  '/admin/settings/tokens': typeof AdminSettingsTokensRoute
  '/admin/settings/trash': typeof AdminSettingsTrashRoute
  '/admin/settings/usage': typeof AdminSettingsUsageRoute
  '/admin/settings/webhooks': typeof AdminSettingsWebhooksRoute
  '/admin/dashboards': typeof AdminDashboardsIndexRoute
  '/admin/filters': typeof AdminFiltersIndexRoute
  '/admin/my': typeof AdminMyIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/admin/p/$projectKey/$issueKey': typeof AdminPProjectKeyIssueKeyRoute
  '/admin/p/$projectKey/automation': typeof AdminPProjectKeyAutomationRoute
  '/admin/p/$projectKey/backlog': typeof AdminPProjectKeyBacklogRoute
  '/admin/p/$projectKey/calendar': typeof AdminPProjectKeyCalendarRoute
  '/admin/p/$projectKey/import': typeof AdminPProjectKeyImportRoute
  '/admin/p/$projectKey/list': typeof AdminPProjectKeyListRoute
  '/admin/p/$projectKey/reports': typeof AdminPProjectKeyReportsRoute
  '/admin/p/$projectKey/settings': typeof AdminPProjectKeySettingsRoute
  '/admin/p/$projectKey/timeline': typeof AdminPProjectKeyTimelineRoute
  '/admin/p/$projectKey': typeof AdminPProjectKeyIndexRoute
  '/admin/p/$projectKey/releases/$releaseId': typeof AdminPProjectKeyReleasesReleaseIdRoute
  '/admin/p/$projectKey/releases': typeof AdminPProjectKeyReleasesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/unavailable': typeof UnavailableRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/preferences': typeof AdminPreferencesRoute
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/admin/dashboards/$dashboardId': typeof AdminDashboardsDashboardIdRoute
  '/admin/filters/$filterId': typeof AdminFiltersFilterIdRoute
  '/admin/i/$issueKey': typeof AdminIIssueKeyRoute
  '/admin/my/due': typeof AdminMyDueRoute
  '/admin/my/recent': typeof AdminMyRecentRoute
  '/admin/my/reported': typeof AdminMyReportedRoute
  '/admin/my/watching': typeof AdminMyWatchingRoute
  '/admin/p/$projectKey': typeof AdminPProjectKeyRouteWithChildren
  '/admin/settings/audit': typeof AdminSettingsAuditRoute
  '/admin/settings/github': typeof AdminSettingsGithubRoute
  '/admin/settings/import': typeof AdminSettingsImportRoute
  '/admin/settings/labels': typeof AdminSettingsLabelsRoute
  '/admin/settings/people': typeof AdminSettingsPeopleRoute
  '/admin/settings/slack': typeof AdminSettingsSlackRoute
  '/admin/settings/tokens': typeof AdminSettingsTokensRoute
  '/admin/settings/trash': typeof AdminSettingsTrashRoute
  '/admin/settings/usage': typeof AdminSettingsUsageRoute
  '/admin/settings/webhooks': typeof AdminSettingsWebhooksRoute
  '/admin/dashboards/': typeof AdminDashboardsIndexRoute
  '/admin/filters/': typeof AdminFiltersIndexRoute
  '/admin/my/': typeof AdminMyIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/p/$projectKey/$issueKey': typeof AdminPProjectKeyIssueKeyRoute
  '/admin/p/$projectKey/automation': typeof AdminPProjectKeyAutomationRoute
  '/admin/p/$projectKey/backlog': typeof AdminPProjectKeyBacklogRoute
  '/admin/p/$projectKey/calendar': typeof AdminPProjectKeyCalendarRoute
  '/admin/p/$projectKey/import': typeof AdminPProjectKeyImportRoute
  '/admin/p/$projectKey/list': typeof AdminPProjectKeyListRoute
  '/admin/p/$projectKey/reports': typeof AdminPProjectKeyReportsRoute
  '/admin/p/$projectKey/settings': typeof AdminPProjectKeySettingsRoute
  '/admin/p/$projectKey/timeline': typeof AdminPProjectKeyTimelineRoute
  '/admin/p/$projectKey/': typeof AdminPProjectKeyIndexRoute
  '/admin/p/$projectKey/releases/$releaseId': typeof AdminPProjectKeyReleasesReleaseIdRoute
  '/admin/p/$projectKey/releases/': typeof AdminPProjectKeyReleasesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/signed-out'
    | '/unavailable'
    | '/admin/exports'
    | '/admin/inbox'
    | '/admin/preferences'
    | '/admin/settings'
    | '/admin/'
    | '/admin/dashboards/$dashboardId'
    | '/admin/filters/$filterId'
    | '/admin/i/$issueKey'
    | '/admin/my/due'
    | '/admin/my/recent'
    | '/admin/my/reported'
    | '/admin/my/watching'
    | '/admin/p/$projectKey'
    | '/admin/settings/audit'
    | '/admin/settings/github'
    | '/admin/settings/import'
    | '/admin/settings/labels'
    | '/admin/settings/people'
    | '/admin/settings/slack'
    | '/admin/settings/tokens'
    | '/admin/settings/trash'
    | '/admin/settings/usage'
    | '/admin/settings/webhooks'
    | '/admin/dashboards/'
    | '/admin/filters/'
    | '/admin/my/'
    | '/admin/settings/'
    | '/admin/p/$projectKey/$issueKey'
    | '/admin/p/$projectKey/automation'
    | '/admin/p/$projectKey/backlog'
    | '/admin/p/$projectKey/calendar'
    | '/admin/p/$projectKey/import'
    | '/admin/p/$projectKey/list'
    | '/admin/p/$projectKey/reports'
    | '/admin/p/$projectKey/settings'
    | '/admin/p/$projectKey/timeline'
    | '/admin/p/$projectKey/'
    | '/admin/p/$projectKey/releases/$releaseId'
    | '/admin/p/$projectKey/releases/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signed-out'
    | '/unavailable'
    | '/admin/exports'
    | '/admin/inbox'
    | '/admin/preferences'
    | '/admin'
    | '/admin/dashboards/$dashboardId'
    | '/admin/filters/$filterId'
    | '/admin/i/$issueKey'
    | '/admin/my/due'
    | '/admin/my/recent'
    | '/admin/my/reported'
    | '/admin/my/watching'
    | '/admin/settings/audit'
    | '/admin/settings/github'
    | '/admin/settings/import'
    | '/admin/settings/labels'
    | '/admin/settings/people'
    | '/admin/settings/slack'
    | '/admin/settings/tokens'
    | '/admin/settings/trash'
    | '/admin/settings/usage'
    | '/admin/settings/webhooks'
    | '/admin/dashboards'
    | '/admin/filters'
    | '/admin/my'
    | '/admin/settings'
    | '/admin/p/$projectKey/$issueKey'
    | '/admin/p/$projectKey/automation'
    | '/admin/p/$projectKey/backlog'
    | '/admin/p/$projectKey/calendar'
    | '/admin/p/$projectKey/import'
    | '/admin/p/$projectKey/list'
    | '/admin/p/$projectKey/reports'
    | '/admin/p/$projectKey/settings'
    | '/admin/p/$projectKey/timeline'
    | '/admin/p/$projectKey'
    | '/admin/p/$projectKey/releases/$releaseId'
    | '/admin/p/$projectKey/releases'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/signed-out'
    | '/unavailable'
    | '/admin/exports'
    | '/admin/inbox'
    | '/admin/preferences'
    | '/admin/settings'
    | '/admin/'
    | '/admin/dashboards/$dashboardId'
    | '/admin/filters/$filterId'
    | '/admin/i/$issueKey'
    | '/admin/my/due'
    | '/admin/my/recent'
    | '/admin/my/reported'
    | '/admin/my/watching'
    | '/admin/p/$projectKey'
    | '/admin/settings/audit'
    | '/admin/settings/github'
    | '/admin/settings/import'
    | '/admin/settings/labels'
    | '/admin/settings/people'
    | '/admin/settings/slack'
    | '/admin/settings/tokens'
    | '/admin/settings/trash'
    | '/admin/settings/usage'
    | '/admin/settings/webhooks'
    | '/admin/dashboards/'
    | '/admin/filters/'
    | '/admin/my/'
    | '/admin/settings/'
    | '/admin/p/$projectKey/$issueKey'
    | '/admin/p/$projectKey/automation'
    | '/admin/p/$projectKey/backlog'
    | '/admin/p/$projectKey/calendar'
    | '/admin/p/$projectKey/import'
    | '/admin/p/$projectKey/list'
    | '/admin/p/$projectKey/reports'
    | '/admin/p/$projectKey/settings'
    | '/admin/p/$projectKey/timeline'
    | '/admin/p/$projectKey/'
    | '/admin/p/$projectKey/releases/$releaseId'
    | '/admin/p/$projectKey/releases/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  SignedOutRoute: typeof SignedOutRoute
  UnavailableRoute: typeof UnavailableRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unavailable': {
      id: '/unavailable'
      path: '/unavailable'
      fullPath: '/unavailable'
      preLoaderRoute: typeof UnavailableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/exports': {
      id: '/admin/exports'
      path: '/exports'
      fullPath: '/admin/exports'
      preLoaderRoute: typeof AdminExportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/inbox': {
      id: '/admin/inbox'
      path: '/inbox'
      fullPath: '/admin/inbox'
      preLoaderRoute: typeof AdminInboxRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/preferences': {
      id: '/admin/preferences'
      path: '/preferences'
      fullPath: '/admin/preferences'
      preLoaderRoute: typeof AdminPreferencesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboards/': {
      id: '/admin/dashboards/'
      path: '/dashboards'
      fullPath: '/admin/dashboards/'
      preLoaderRoute: typeof AdminDashboardsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboards/$dashboardId': {
      id: '/admin/dashboards/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/admin/dashboards/$dashboardId'
      preLoaderRoute: typeof AdminDashboardsDashboardIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/filters/': {
      id: '/admin/filters/'
      path: '/filters'
      fullPath: '/admin/filters/'
      preLoaderRoute: typeof AdminFiltersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/filters/$filterId': {
      id: '/admin/filters/$filterId'
      path: '/filters/$filterId'
      fullPath: '/admin/filters/$filterId'
      preLoaderRoute: typeof AdminFiltersFilterIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/i/$issueKey': {
      id: '/admin/i/$issueKey'
      path: '/i/$issueKey'
      fullPath: '/admin/i/$issueKey'
      preLoaderRoute: typeof AdminIIssueKeyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/my/': {
      id: '/admin/my/'
      path: '/my'
      fullPath: '/admin/my/'
      preLoaderRoute: typeof AdminMyIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/my/due': {
      id: '/admin/my/due'
      path: '/my/due'
      fullPath: '/admin/my/due'
      preLoaderRoute: typeof AdminMyDueRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/my/recent': {
      id: '/admin/my/recent'
      path: '/my/recent'
      fullPath: '/admin/my/recent'
      preLoaderRoute: typeof AdminMyRecentRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/my/reported': {
      id: '/admin/my/reported'
      path: '/my/reported'
      fullPath: '/admin/my/reported'
      preLoaderRoute: typeof AdminMyReportedRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/my/watching': {
      id: '/admin/my/watching'
      path: '/my/watching'
      fullPath: '/admin/my/watching'
      preLoaderRoute: typeof AdminMyWatchingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/p/$projectKey': {
      id: '/admin/p/$projectKey'
      path: '/p/$projectKey'
      fullPath: '/admin/p/$projectKey'
      preLoaderRoute: typeof AdminPProjectKeyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/audit': {
      id: '/admin/settings/audit'
      path: '/audit'
      fullPath: '/admin/settings/audit'
      preLoaderRoute: typeof AdminSettingsAuditRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/github': {
      id: '/admin/settings/github'
      path: '/github'
      fullPath: '/admin/settings/github'
      preLoaderRoute: typeof AdminSettingsGithubRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/import': {
      id: '/admin/settings/import'
      path: '/import'
      fullPath: '/admin/settings/import'
      preLoaderRoute: typeof AdminSettingsImportRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/labels': {
      id: '/admin/settings/labels'
      path: '/labels'
      fullPath: '/admin/settings/labels'
      preLoaderRoute: typeof AdminSettingsLabelsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/people': {
      id: '/admin/settings/people'
      path: '/people'
      fullPath: '/admin/settings/people'
      preLoaderRoute: typeof AdminSettingsPeopleRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/slack': {
      id: '/admin/settings/slack'
      path: '/slack'
      fullPath: '/admin/settings/slack'
      preLoaderRoute: typeof AdminSettingsSlackRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/tokens': {
      id: '/admin/settings/tokens'
      path: '/tokens'
      fullPath: '/admin/settings/tokens'
      preLoaderRoute: typeof AdminSettingsTokensRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/trash': {
      id: '/admin/settings/trash'
      path: '/trash'
      fullPath: '/admin/settings/trash'
      preLoaderRoute: typeof AdminSettingsTrashRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/usage': {
      id: '/admin/settings/usage'
      path: '/usage'
      fullPath: '/admin/settings/usage'
      preLoaderRoute: typeof AdminSettingsUsageRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/webhooks': {
      id: '/admin/settings/webhooks'
      path: '/webhooks'
      fullPath: '/admin/settings/webhooks'
      preLoaderRoute: typeof AdminSettingsWebhooksRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/p/$projectKey/': {
      id: '/admin/p/$projectKey/'
      path: '/'
      fullPath: '/admin/p/$projectKey/'
      preLoaderRoute: typeof AdminPProjectKeyIndexRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/$issueKey': {
      id: '/admin/p/$projectKey/$issueKey'
      path: '/$issueKey'
      fullPath: '/admin/p/$projectKey/$issueKey'
      preLoaderRoute: typeof AdminPProjectKeyIssueKeyRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/automation': {
      id: '/admin/p/$projectKey/automation'
      path: '/automation'
      fullPath: '/admin/p/$projectKey/automation'
      preLoaderRoute: typeof AdminPProjectKeyAutomationRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/backlog': {
      id: '/admin/p/$projectKey/backlog'
      path: '/backlog'
      fullPath: '/admin/p/$projectKey/backlog'
      preLoaderRoute: typeof AdminPProjectKeyBacklogRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/calendar': {
      id: '/admin/p/$projectKey/calendar'
      path: '/calendar'
      fullPath: '/admin/p/$projectKey/calendar'
      preLoaderRoute: typeof AdminPProjectKeyCalendarRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/import': {
      id: '/admin/p/$projectKey/import'
      path: '/import'
      fullPath: '/admin/p/$projectKey/import'
      preLoaderRoute: typeof AdminPProjectKeyImportRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/list': {
      id: '/admin/p/$projectKey/list'
      path: '/list'
      fullPath: '/admin/p/$projectKey/list'
      preLoaderRoute: typeof AdminPProjectKeyListRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/reports': {
      id: '/admin/p/$projectKey/reports'
      path: '/reports'
      fullPath: '/admin/p/$projectKey/reports'
      preLoaderRoute: typeof AdminPProjectKeyReportsRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/settings': {
      id: '/admin/p/$projectKey/settings'
      path: '/settings'
      fullPath: '/admin/p/$projectKey/settings'
      preLoaderRoute: typeof AdminPProjectKeySettingsRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/timeline': {
      id: '/admin/p/$projectKey/timeline'
      path: '/timeline'
      fullPath: '/admin/p/$projectKey/timeline'
      preLoaderRoute: typeof AdminPProjectKeyTimelineRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/releases/': {
      id: '/admin/p/$projectKey/releases/'
      path: '/releases'
      fullPath: '/admin/p/$projectKey/releases/'
      preLoaderRoute: typeof AdminPProjectKeyReleasesIndexRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
    '/admin/p/$projectKey/releases/$releaseId': {
      id: '/admin/p/$projectKey/releases/$releaseId'
      path: '/releases/$releaseId'
      fullPath: '/admin/p/$projectKey/releases/$releaseId'
      preLoaderRoute: typeof AdminPProjectKeyReleasesReleaseIdRouteImport
      parentRoute: typeof AdminPProjectKeyRoute
    }
  }
}

interface AdminSettingsRouteChildren {
  AdminSettingsAuditRoute: typeof AdminSettingsAuditRoute
  AdminSettingsGithubRoute: typeof AdminSettingsGithubRoute
  AdminSettingsImportRoute: typeof AdminSettingsImportRoute
  AdminSettingsLabelsRoute: typeof AdminSettingsLabelsRoute
  AdminSettingsPeopleRoute: typeof AdminSettingsPeopleRoute
  AdminSettingsSlackRoute: typeof AdminSettingsSlackRoute
  AdminSettingsTokensRoute: typeof AdminSettingsTokensRoute
  AdminSettingsTrashRoute: typeof AdminSettingsTrashRoute
  AdminSettingsUsageRoute: typeof AdminSettingsUsageRoute
  AdminSettingsWebhooksRoute: typeof AdminSettingsWebhooksRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
}

const AdminSettingsRouteChildren: AdminSettingsRouteChildren = {
  AdminSettingsAuditRoute: AdminSettingsAuditRoute,
  AdminSettingsGithubRoute: AdminSettingsGithubRoute,
  AdminSettingsImportRoute: AdminSettingsImportRoute,
  AdminSettingsLabelsRoute: AdminSettingsLabelsRoute,
  AdminSettingsPeopleRoute: AdminSettingsPeopleRoute,
  AdminSettingsSlackRoute: AdminSettingsSlackRoute,
  AdminSettingsTokensRoute: AdminSettingsTokensRoute,
  AdminSettingsTrashRoute: AdminSettingsTrashRoute,
  AdminSettingsUsageRoute: AdminSettingsUsageRoute,
  AdminSettingsWebhooksRoute: AdminSettingsWebhooksRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(
  AdminSettingsRouteChildren,
)

interface AdminPProjectKeyRouteChildren {
  AdminPProjectKeyIssueKeyRoute: typeof AdminPProjectKeyIssueKeyRoute
  AdminPProjectKeyAutomationRoute: typeof AdminPProjectKeyAutomationRoute
  AdminPProjectKeyBacklogRoute: typeof AdminPProjectKeyBacklogRoute
  AdminPProjectKeyCalendarRoute: typeof AdminPProjectKeyCalendarRoute
  AdminPProjectKeyImportRoute: typeof AdminPProjectKeyImportRoute
  AdminPProjectKeyListRoute: typeof AdminPProjectKeyListRoute
  AdminPProjectKeyReportsRoute: typeof AdminPProjectKeyReportsRoute
  AdminPProjectKeySettingsRoute: typeof AdminPProjectKeySettingsRoute
  AdminPProjectKeyTimelineRoute: typeof AdminPProjectKeyTimelineRoute
  AdminPProjectKeyIndexRoute: typeof AdminPProjectKeyIndexRoute
  AdminPProjectKeyReleasesReleaseIdRoute: typeof AdminPProjectKeyReleasesReleaseIdRoute
  AdminPProjectKeyReleasesIndexRoute: typeof AdminPProjectKeyReleasesIndexRoute
}

const AdminPProjectKeyRouteChildren: AdminPProjectKeyRouteChildren = {
  AdminPProjectKeyIssueKeyRoute: AdminPProjectKeyIssueKeyRoute,
  AdminPProjectKeyAutomationRoute: AdminPProjectKeyAutomationRoute,
  AdminPProjectKeyBacklogRoute: AdminPProjectKeyBacklogRoute,
  AdminPProjectKeyCalendarRoute: AdminPProjectKeyCalendarRoute,
  AdminPProjectKeyImportRoute: AdminPProjectKeyImportRoute,
  AdminPProjectKeyListRoute: AdminPProjectKeyListRoute,
  AdminPProjectKeyReportsRoute: AdminPProjectKeyReportsRoute,
  AdminPProjectKeySettingsRoute: AdminPProjectKeySettingsRoute,
  AdminPProjectKeyTimelineRoute: AdminPProjectKeyTimelineRoute,
  AdminPProjectKeyIndexRoute: AdminPProjectKeyIndexRoute,
  AdminPProjectKeyReleasesReleaseIdRoute:
    AdminPProjectKeyReleasesReleaseIdRoute,
  AdminPProjectKeyReleasesIndexRoute: AdminPProjectKeyReleasesIndexRoute,
}

const AdminPProjectKeyRouteWithChildren =
  AdminPProjectKeyRoute._addFileChildren(AdminPProjectKeyRouteChildren)

interface AdminRouteChildren {
  AdminExportsRoute: typeof AdminExportsRoute
  AdminInboxRoute: typeof AdminInboxRoute
  AdminPreferencesRoute: typeof AdminPreferencesRoute
  AdminSettingsRoute: typeof AdminSettingsRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminDashboardsDashboardIdRoute: typeof AdminDashboardsDashboardIdRoute
  AdminFiltersFilterIdRoute: typeof AdminFiltersFilterIdRoute
  AdminIIssueKeyRoute: typeof AdminIIssueKeyRoute
  AdminMyDueRoute: typeof AdminMyDueRoute
  AdminMyRecentRoute: typeof AdminMyRecentRoute
  AdminMyReportedRoute: typeof AdminMyReportedRoute
  AdminMyWatchingRoute: typeof AdminMyWatchingRoute
  AdminPProjectKeyRoute: typeof AdminPProjectKeyRouteWithChildren
  AdminDashboardsIndexRoute: typeof AdminDashboardsIndexRoute
  AdminFiltersIndexRoute: typeof AdminFiltersIndexRoute
  AdminMyIndexRoute: typeof AdminMyIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminExportsRoute: AdminExportsRoute,
  AdminInboxRoute: AdminInboxRoute,
  AdminPreferencesRoute: AdminPreferencesRoute,
  AdminSettingsRoute: AdminSettingsRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminDashboardsDashboardIdRoute: AdminDashboardsDashboardIdRoute,
  AdminFiltersFilterIdRoute: AdminFiltersFilterIdRoute,
  AdminIIssueKeyRoute: AdminIIssueKeyRoute,
  AdminMyDueRoute: AdminMyDueRoute,
  AdminMyRecentRoute: AdminMyRecentRoute,
  AdminMyReportedRoute: AdminMyReportedRoute,
  AdminMyWatchingRoute: AdminMyWatchingRoute,
  AdminPProjectKeyRoute: AdminPProjectKeyRouteWithChildren,
  AdminDashboardsIndexRoute: AdminDashboardsIndexRoute,
  AdminFiltersIndexRoute: AdminFiltersIndexRoute,
  AdminMyIndexRoute: AdminMyIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  SignedOutRoute: SignedOutRoute,
  UnavailableRoute: UnavailableRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
